<template>
  <picker v-if="loaded" v-model="colour" :disabled="disable" @input="$emit('input', colour.hex)"></picker>
</template>

<script>
import { Compact } from 'vue-color'

export default {
  props: ['value', 'disable'],
  data: function () {
    return {
      colour: {},
      loaded: false
    }
  },
  components: {
    picker: Compact
  },
  mounted: function () {
    this.colour.hex = this.value
    this.loaded = true
  }
}
</script>

<style lang="scss">
  div.vc-compact {
    box-shadow: none;
    width: 100%;

    &[disabled] {
      opacity: 0.2;
      pointer-events: none;
    }

    .vc-compact-colors {
      .vc-compact-color-item {
        width: 7%;
        padding: 3.5%;
        margin: 0.6%;
      }
    }
  }
</style>
